import { MaterialIcon } from '@pelckmans/business-components/components/material-icon';
import { Medialink } from '../../_api/MedialinksApi';

export default function MedialinkContentType({ medialink }: { medialink: Medialink }) {
  return (
    <>
      <MaterialIcon materialType="medialink" contentType={medialink.contentType} className="icon" />
      {medialink.contentType.name}
    </>
  );
}
